/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  AgentPolicySelector,
  AgentPolicySelector$Outbound,
  AgentPolicySelector$outboundSchema,
} from "./agentpolicyselector.js";

export type AgentExpectedPolicy = {
  /**
   * Scope of the grant originally read
   */
  scope: string;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
};

/** @internal */
export type AgentExpectedPolicy$Outbound = {
  scope: string;
  selector: AgentPolicySelector$Outbound;
};

/** @internal */
export const AgentExpectedPolicy$outboundSchema: z.ZodMiniType<
  AgentExpectedPolicy$Outbound,
  AgentExpectedPolicy
> = z.object({
  scope: z.string(),
  selector: AgentPolicySelector$outboundSchema,
});

export function agentExpectedPolicyToJSON(
  agentExpectedPolicy: AgentExpectedPolicy,
): string {
  return JSON.stringify(
    AgentExpectedPolicy$outboundSchema.parse(agentExpectedPolicy),
  );
}
